var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"price_other_exchange"}},[_c('ul',{staticClass:"list_coin_compare clearfix"},_vm._l((_vm.prices),function(value,key){return _c('li',[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm._f("upperFirst")(key)))]),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatCurrencyAmount")(value,'usd', '0')))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }